import React from 'react';
import { ReactConversation } from '@indeed/messaging-react';

interface ConversationContainerProps {
    conversationId: string;
    isAutoResizeEnabled: boolean;
    renderBeforeListComponents?: React.ReactNode[];
    navigationHandlers?: {
        onBackClick?: () => void;
        onNavigateToJobDetails?: () => void;
    };
}

const ConversationContainer: React.FC<ConversationContainerProps> = ({
    conversationId,
    isAutoResizeEnabled,
    renderBeforeListComponents,
    navigationHandlers,
}) => {
    return (
        <ReactConversation
            conversationId={conversationId}
            isAutoResizeEnabled={isAutoResizeEnabled}
            renderBeforeListComponents={renderBeforeListComponents}
            navigationHandlers={navigationHandlers}
        />
    );
};

export default ConversationContainer;
